"use strict";

class StationSettingsVTunerCtrl
{
    constructor($rootScope, $http, $mdToast, $scope, $mdDialog)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        $scope.$watch(() => {
            return $scope.vtunerform.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

        this.exportData = {
            vtuner: {}
        };

        $rootScope.saveSettings = () => {
            this.save();
        };

        this.fetch();
    }

    fetch()
    {
        this.$http.get('/stationsettings/export/vtuner').then(response => {
            this.exportData = response.data;
        });
    }

    save()
    {
        this.$rootScope.saveDisabled = true;
        this.$http.put('/stationsettings/export', this.exportData).then(() => {

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=vTuner', //@trans('labels.Export')
                hideDelay: 6000,
                position: ('top right')
            });

            this.$rootScope.saveDisabled = false;
        });
    }

    saveOne(name, key, data) {
        this.$rootScope.saveDisabled = true;
        data.last = new Date();

        let list = {};
        list[key] = data;
        this.$http.put('/stationsettings/export', list).then(() => {
            this.$rootScope.saveDisabled = false;
        });
    }

    sendVtunerEmail(name) {
        this.$http.post('/stationsettings/send/vtuner').then(() => {

            this.saveOne(name, 'vtuner', this.exportData.vtuner);
        });
    }

    checkButtonDisabled(lastSend) {
        if(!lastSend) {
            return false;
        }

        lastSend = new Date(lastSend);
        let now = new Date();
        now.setHours(now.getHours() -1);

        return lastSend >= now;
    }

}

StationSettingsVTunerCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$scope', '$mdDialog'];

module.exports = StationSettingsVTunerCtrl;
